import { ComponentType, lazy, ReactNode, Suspense } from 'react'
import { LucideProps } from 'lucide-react'
import dynamicIconImports from 'lucide-react/dynamicIconImports'
import Icon from '@ant-design/icons'
import type { GetProps } from 'antd'

type CustomIconComponentProps = GetProps<typeof Icon>
export type DynamicLucideKey = keyof typeof dynamicIconImports

const Fallback = () => (
  <svg
    style={{
      background: '#ddd',
      width: 16,
      height: 16,
      borderRadius: 100,
    }}
  />
)

type IconProps = Omit<LucideProps, 'ref'> & {
  name: DynamicLucideKey
} & Pick<Partial<CustomIconComponentProps>, 'spin' | 'rotate'>

// Create a lazy component cache
const iconCache = new Map<string, ComponentType<any>>()

function getLazyIcon(name: DynamicLucideKey) {
  if (!iconCache.has(name)) {
    iconCache.set(name, lazy(dynamicIconImports[name]))
  }
  return iconCache.get(name)!
}

const IconGlobalApp = ({
  name,
  size = 16,
  strokeWidth = 1.5,
  spin,
  rotate,
  fallBack,
  ...props
}: IconProps & { fallBack?: ReactNode }) => {
  const LucideIcon = getLazyIcon(name)

  const component = () => (
    <Suspense fallback={fallBack || <Fallback />}>
      <LucideIcon size={size} strokeWidth={strokeWidth} {...props} />
    </Suspense>
  )

  return <Icon component={component} spin={spin} rotate={rotate} />
}

export default IconGlobalApp
